import { Button, ConfirmationDialog } from 'components/Elements';
import PropTypes from 'prop-types';
import { useBanUser } from '../api/banUser'; // You'll need to implement this hook
import { Ban } from 'lucide-react';

export const BanUser = ({ id, userName }) => {
  const banUserMutation = useBanUser({ id });

  return (
    <ConfirmationDialog
      icon="danger"
      title="Ban User"
      body={`Are you sure you want to ban "${userName}"? This action is irreversible.`}
      triggerButton={
        <button className="text-xs px-3 py-1 border border-white/10 rounded-md hover:bg-white/10 flex items-center space-x-1">
          <Ban size={14} />
          <span>Ban</span>
        </button>
      }
      confirmButton={
        <Button
          isLoading={banUserMutation.isLoading}
          type="button"
          variant="danger"
          onClick={() => {
            banUserMutation.mutate({ id });
          }}
        >
          Confirm Ban
        </Button>
      }
    />
  );
};

BanUser.propTypes = {
  id: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};
